var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDress3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1075 2.99888C17.1075 2.44721 16.6501 2 16.086 2H14.1282L13.6187 3.79358C13.4167 4.50458 12.7547 4.99663 12.0001 4.99663C11.2455 4.99663 10.5835 4.50458 10.3815 3.79359L9.87199 2H7.91417C7.35002 2 6.8927 2.44721 6.8927 2.99888V3.93662C6.8927 5.30558 7.03659 6.67092 7.32211 8.01112L7.58432 9.24185H16.4158L16.678 8.01112C16.9636 6.67092 17.1075 5.30558 17.1075 3.93661V2.99888Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.508 10.7402H7.49197L4.09604 17.7668C3.93596 18.0509 3.97895 18.4032 4.2029 18.6424C8.39297 23.1192 15.607 23.1192 19.7971 18.6424C20.021 18.4032 20.064 18.0509 19.904 17.7668L16.508 10.7402Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress3);
export default __webpack_public_path__ + "static/media/dress-3.27bb1fa44b5c08d88f7892cda9c8eb93.svg";
export { ForwardRef as ReactComponent };